






























































































































import Vue from "vue";
import { mapState } from "vuex";
export default Vue.extend({
  name: "App",

  components: {},

  data: () => ({
    drawer: true,
    unsubscribe: null,
    breadcrumbs: [
      {
        text: "Home"
      },
      {
        text: "Dashboard"
      }
    ],
    routeName: "Home",
    linksBase: [
      {
        name: "Home",
        icon: "fas fa-tachometer-alt",
        text: "Dashboard",
        textM: "HOME",
        link: "/"
      },
      {
        name: "Pages",
        icon: "fas fa-desktop",
        text: "Páginas",
        textM: "PÁGINAS",
        link: "/pages"
      },
      {
        name: "Links",
        icon: "fas fa-link",
        text: "Links",
        textM: "LINKS",
        link: "/links"
      },
      {
        name: "Phones",
        icon: "fas fa-mobile-alt",
        text: "Números",
        textM: "NÚMEROS",
        link: "/phones"
      },
      {
        name: "Configs",
        icon: "far fa-user",
        text: "Minha Conta",
        textM: "CONTA",
        link: "/profile/user"
      }
    ]
  }),
  computed: {
    links: function() {
      const menuLinks: any = [];
      this.linksBase.forEach((element) => {
        if (element.name == "Pages") {
          if (this.hasPages) {
            menuLinks.push(element);
          }
        } else {
          menuLinks.push(element);
        }
      });
      return menuLinks;
    },
    formatUserName: function() {
      let name = this.userName;
      if (this.isMobile) {
        name = name.replace(" ", "<br>");
      }
      return name;
    },
    formatBreadcrumbs: function() {
      const breadcrumbs = [];
      let text: any = "";
      this.links.forEach((Element: any) => {
        if (Element.name == this.routeName) {
          text = Element.text;
        }
      });
      if (text == "Home") {
        breadcrumbs.push({ text: "Home" });
      } else {
        breadcrumbs.push({ text: "Home" });
        breadcrumbs.push({ text: text });
      }
      return breadcrumbs;
    },
    ...mapState({
      userName: (state: any) => state.appStore.userName,
      isLoggedIn: (state: any) => state.appStore.isLoggedIn,
      isMobile: (state: any) => state.appStore.isMobile,
      isPortrait: (state: any) => state.appStore.isPortrait,
      hasPages: (state: any) => state.appStore.hasPages
    })
  },
  methods: {
    gotoToRoute: function(link: string) {
      this.$router.push(link).catch(() => {
        //
      });
    },
    logoutUser: function() {
      this.$store.dispatch("authStore/logout");
    },
    reloadOnResize() {
      this.$store.dispatch("appStore/setShowGraph", false).then(() => {
        this.$store.dispatch("appStore/checkIfIsMobile").then(() => {
          this.$store.dispatch("appStore/setShowGraph", true);
        });
      });
    }
  },
  mounted() {
    this.$store.dispatch("appStore/getUserName");
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "route/ROUTE_CHANGED") {
        this.routeName = state.route.name;
      }
    });
    this.$store.dispatch("appStore/setShowGraph", false).then(() => {
      this.$store.dispatch("appStore/checkIfIsMobile").then(() => {
        this.$store.dispatch("appStore/setShowGraph", true);
      });
    });
    this.$nextTick(function() {
      window.addEventListener("resize", (this as any).reloadOnResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", (this as any).reloadOnResize);
  }
});
